import React from 'react';
import {useTranslation} from 'react-i18next';
import {useUiVersion} from '../../context/UserModulesContext';
import {AlertRecipients} from './AlertRecipients';

/**
 * «Quién recibe por mail las alertas de esta línea»: una sección al pie de la caja de la configuración de
 * alertas de la línea. Va en un archivo aparte de `AlertRecipients` para que «Ahora» no arrastre el
 * contexto de módulos (y con él react-router) a sus tests.
 *
 * Adentro de la caja y no en una caja propia: la pantalla es `.section-body.h-items`, una fila flex, y
 * una segunda caja de 940 px caía al costado de la primera.
 *
 * Sólo en la 2.1: sus estilos cuelgan de `.ui-v2` y el clásico no se toca. Hasta que se sabe el marco, o si
 * el endpoint no contesta, no se dibuja nada (`AlertRecipients` devuelve `null`).
 */
export function LineAlertRecipients({clientId}) {
    const {t} = useTranslation();
    const {isV2, loaded} = useUiVersion();
    if (!loaded || !isV2 || clientId == null) return null;
    return (
        <AlertRecipients clientId={clientId}
                         renderFrame={(content) => (
                             <section className="alr-line-section" data-testid="alr-line-section"
                                      aria-labelledby="alr-line-title">
                                 <h3 id="alr-line-title" className="alr-line-section__title">
                                     {t('alerts_recipients.title_line')}
                                 </h3>
                                 {content}
                             </section>
                         )}/>
    );
}

export default LineAlertRecipients;
